import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: password });
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="block text-center font-display text-3xl font-black uppercase text-white mb-8">
          The <span className="text-[#a855f7]">Pooh Sheet</span>
        </Link>
        <div className="card-surface rounded-xl p-8">
          <h1 className="font-display text-2xl font-bold uppercase text-white">Set new password</h1>
          {!token ? (
            <p className="text-red-400 text-sm mt-4" data-testid="reset-no-token">
              Missing reset token. <Link to="/forgot-password" className="text-[#a855f7] hover:underline">Request a new link</Link>.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">New password</label>
                <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password-input"
                  className="mt-1 w-full bg-[#0a0a0a] border border-white/15 focus:border-[#a855f7] rounded px-3 py-2.5 text-white text-sm outline-none transition-colors duration-200" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">Confirm password</label>
                <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-confirm-input"
                  className="mt-1 w-full bg-[#0a0a0a] border border-white/15 focus:border-[#a855f7] rounded px-3 py-2.5 text-white text-sm outline-none transition-colors duration-200" />
              </div>
              {error && <div className="text-red-400 text-sm" data-testid="reset-error">{error}</div>}
              <button type="submit" disabled={busy} data-testid="reset-submit-btn"
                className="w-full bg-[#a855f7] hover:bg-[#9333ea] disabled:opacity-50 text-black font-bold uppercase tracking-wider py-3 rounded transition-colors duration-200">
                {busy ? "Updating..." : "Update password"}
              </button>
            </form>
          )}
          <p className="text-sm text-neutral-500 mt-5 text-center">
            <Link to="/login" data-testid="reset-goto-login" className="text-[#a855f7] hover:underline">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
